export default "__VITE_ASSET__tl57w8tE__"